import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import type { components } from "../types/api.types";
import urls from "../urls";

export type SiteNotification = components["schemas"]["SiteNotification"];

export function useSiteNotifications(
  siteId: number,
  options?: Partial<UseQueryOptions<SiteNotification>>
) {
  return useQuery({
    queryKey: ["siteNotifications", { siteId }],
    queryFn: () => fetchSiteNotifications(siteId),
    ...options
  });
}

async function fetchSiteNotifications(siteId: number) {
  const siteNotificationsUrl =
    urls.apiWithoutCamelization.siteNotifications(siteId);
  const response = await apiWithoutCamelization.get(siteNotificationsUrl);
  return response.data;
}
